import React, { useState, useMemo, useCallback, useEffect } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../GlobalContext';
import { locationName2URL, formatDuration } from '../helpers/utils';
import './ItineraryListview.scss';

const formatDrivingMode = (drivingMode) => {
  const drivingModes = {
    walking: 'Walking',
    driving: 'Driving',
    bicycling: 'Bicycling',
    transit: 'Public Transit',
  };
  return drivingModes[drivingMode];
};

const EventComponent = ({ event, prevEvent }) => {
  const [showImage, setShowImage] = useState(true);

  const handleImageError = useCallback(() => {
    setShowImage(false);
  }, []);

  const route = event?.route;
  const mapLink = `https://www.google.com/maps/search/?api=1&query=${event.address}`;

  return (
    <React.Fragment key={`event-fragment-${event.id}`}>
      {route && (
        <div key={`route${event.id}`} className="itinerary-item">
          <div className="col-1">
            <img
              src={`/images/${event.drivingMode}.png`}
              alt={event.drivingMode}
            />
          </div>
          <div className="col-2">
            <h5>{event.time}</h5>
            <p>{formatDuration(route.duration)}</p>
          </div>
          <div className="col-3">
            <h3>{formatDrivingMode(event.drivingMode)}</h3>
            <p>
              <a
                style={{ marginTop: 5 }}
                href={`https://www.google.com/maps/dir/?api=1&origin=${prevEvent.address}&destination=${event.address}&travelmode=${event.drivingMode}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Click to view the route
              </a>
            </p>
          </div>
        </div>
      )}
      <div key={`event${event.id}`} className="itinerary-item">
        <div className="col-1">
          {showImage && (
            <a href={mapLink} target="_blank" rel="noopener noreferrer">
              <img
                src={locationName2URL(event.location, event.city, 96)}
                onError={handleImageError}
                alt={event.location}
              />
            </a>
          )}
        </div>
        <div className="col-2">
          <h5>{event.time}</h5>
          <p>{formatDuration(event.duration)}</p>
          <p>
            {event.price === 0 ? (
              <span className="price-free">Free</span>
            ) : (
              <span className="price">
                {event.currency} {event.price}
              </span>
            )}
          </p>
        </div>
        <div className="col-3">
          <h3>
            <a href={mapLink} target="_blank" rel="noopener noreferrer">
              {event.location}
            </a>
          </h3>
          <p>{event.description}</p>
        </div>
      </div>
    </React.Fragment>
  );
};

const ItineraryListview = () => {
  const { selectedDay, setSelectedDay, days } = useGlobalContext();
  const navigate = useNavigate();
  const day = days[selectedDay];

  useEffect(() => {
    if (!day) {
      navigate('/chat');
    }
  }, [day, navigate]);

  if (!day) {
    return null;
  }

  const { events } = day;

  const eventComponents = useMemo(
    () =>
      events.map((event, i) => {
        const prevEvent = events[i - 1];
        return (
          <EventComponent key={event.id} event={event} prevEvent={prevEvent} />
        );
      }),
    [events],
  );

  return (
    <div className="itinerary-listview-wrapper">
      <div>
        <div className="top">
          <header className="header">Itinerary</header>
          <img
            src="/images/mapview.png"
            alt="Map View"
            role="presentation"
            onClick={() => {
              navigate('/itinerary/mapview');
            }}
          />
        </div>
        <div className="tabs">
          <ul>
            <li>Overview</li>
            {Object.keys(days).map((d) => (
              <li
                key={d}
                className={d === selectedDay ? 'active' : ''}
                onClick={() => setSelectedDay(d)}
                role="presentation"
              >
                Day {d}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {Object.keys(days).length > 0 && (
        <div>
          <div className="itinerary-content">
            <div className="itinerary-day">
              <h2>{moment(events[0].date).format('MM/DD (ddd)')}</h2>
              {eventComponents}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItineraryListview;
